<template>
  <v-container fluid class="tb-layout-browse">
    <ATabulatorLoder :isLoading="isLoading" />
    <AError :api="apiThatReturnedError" />

    <div v-if="this.rolePermission[`${model.permissionKeys.browse}`].isAllowed">
      <BreadHeader :title="model.name.plural">
        <v-btn
          :disabled="
            !model.add ||
            !this.rolePermission[`${model.permissionKeys.add}`].isAllowed
          "
          color="primary"
          :to="{
            name: 'PageServiceModelBreadTabulatorAdd',
            params: {
              serviceKey: model.serviceKey,
              modelKey: model.key,
            },
          }"
          >+ New {{ model.name.singular }}</v-btn
        >
      </BreadHeader>

      <v-row class="tb-filter-section">
        <v-row no-gutters>
          <v-col md="4">
            <div class="tb-left-second-section">
              <div>
                <h5
                  v-if="switchToAdvanceFilter == true"
                  @click="switchToAdvanceFilter = false"
                  style="cursor: pointer"
                >
                  Switch to Normal Filter
                </h5>
                <h5
                  v-if="switchToAdvanceFilter == true"
                  @click="switchToAdvanceFilter = true"
                  style="cursor: pointer"
                >
                  Switch to Advance Filter
                </h5>
              </div>
              <div>
                <h4 v-on:click="isShow = !isShow" style="float: left">
                  Filter
                  <v-icon left> mdi mdi-menu-down </v-icon>
                </h4>
                <span v-if="switchToAdvanceFilter == false">
                  {{ conditions.length }} Filter Applied
                </span>
              </div>
            </div>
          </v-col>
          <v-col md="8">
            <!-- include column selection compnent -->

            <BreadTabulatorSelectColumn
              ref="selectColumn"
              :model="model"
              @applyColumnSelection="applyColumnSelection"
            ></BreadTabulatorSelectColumn>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-2">
          <v-col md="12">
            <div class="tb-normal-filter" v-show="isShow">
              <div
                class="tb-filter-area"
                v-show="switchToAdvanceFilter == false"
              >
                <BreadTabulatorFilterable
                  ref="filter"
                  :model="model"
                  :setConditions="setConditions"
                ></BreadTabulatorFilterable>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-row>

      <!-- defult search area-->
      <div class="tb-search-area">
        <v-row>
          <v-col md="6">
            <BreadTabulatorSearchable
              ref="search"
              :model="model"
              :setConditions="setConditions"
            ></BreadTabulatorSearchable>
            <div>
              <span
                id="record-count"
                style="float: left; font-size: 12px"
              ></span>
            </div>
          </v-col>

          <v-col md="6" align="right">
            <v-row no-gutters>
              <v-col md="4">
                <div
                  v-if="
                    this.allowCellEditOption &&
                    this.rolePermission[`${model.permissionKeys.edit}`]
                      .isAllowed
                  "
                >
                  <v-btn
                    @click="setIsEditableCell(true)"
                    v-if="this.cellEditableStatus == true"
                    >Enable Cell Edit</v-btn
                  >
                  <v-btn
                    @click="setIsEditableCell(false)"
                    v-if="this.cellEditableStatus == false"
                    >Disable Cell Edit</v-btn
                  >
                </div>
              </v-col>
              <v-col md="8">
                <v-btn-toggle dense multiple class="mr-1">
                  <BreadTabulatorUpload
                    ref="excelUpload"
                    :model="model"
                  ></BreadTabulatorUpload>
                  <!-- have to include data download component-->
                  <BreadTabulatorExport
                    ref="exportData"
                    :model="model"
                    :apiUrl="this.apiGetBrowseUrl()"
                    @downloadData="downloadData"
                  >
                  </BreadTabulatorExport>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <!-- table area with tabs-->
      <BreadTabulatorViewLatest
        ref="customView"
        :model="model"
        :selectedCustomColums="this.selectedCustomColums"
        :selectedAdvanceFilterConditions="this.selectedAdvanceFilterConditions"
        :selectedFilterConditions="this.selectedFilterConditions"
        :cColumnSort="this.cColumnSort"
        :displayRowCount="this.displayRowCount"
        :listAllViews="this.listAllViews"
        :allResizeColumns="this.allResizeColumns"
        @changeTableDetails="changeTableDetails"
      ></BreadTabulatorViewLatest>

      <BreadTabulator
        ref="tabulatorDataTable"
        layout="fitColumns"
        :autoColumns="false"
        :paginationSize="this.paginationSize"
        :paginationSizeSelector="this.paginationSizeSelector"
        :apiUrl="this.apiGetBrowseUrl()"
        :columns="this.columns"
        :modelKey="this.modelKey"
        :columnSelectionDisabledCount="this.columnSelectionDisabledCount"
        @updateEditedCellData="updateEditedCellData"
        @getCurrentPageSize="getCurrentPageSize"
        @getCurrentSort="getCurrentSort"
        @getCurrentColumnWidth="getCurrentColumnWidth"
        @getCurrentPageNumber="getCurrentPageNumber"
        @getSelectedRows="getSelectedRows"
        @getDataLoadErrorCode="getDataLoadErrorCode"
      ></BreadTabulator>
    </div>
    <div v-else>
      <v-row>
        <v-col md="12">
          <v-alert
            type="error"
            dismissible
            border="left"
            elevation="2"
            icon="mdi-alert"
          >
            You don't have permission to browse this model.
          </v-alert>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Api from "@/objects/api";
import BreadcrumbTabulator from "@/objects/breadcrumbTabulator";
import Model from "@/objects/model";
import Service from "@/objects/service";
import BreadTabulatorUpload from "../../../components/common/BreadTabulatorUpload.vue";
import { mapState } from "vuex";

export default {
  components: {
    BreadTabulatorUpload,
  },
  computed: mapState({
    auth: (state) => state.auth.data,
    services: (state) => state.service.data.services,
    rolePermission: (state) => state.rolePermission.data,
  }),
  data: () => ({
    api: new Api(),
    apiTrash: new Api(),
    apiDropdown: new Api(),
    breadcrumbTabulator: new BreadcrumbTabulator(),
    apiTeam: new Api(),
    model: new Model(),
    listAllViews: [],
    dataStatus: "active",
    tools: {
      advancedBar: [2, 3],
      enableColumnSelection: true,
      enableRowSelection: true,
      enableSearch: true,
      showAdvancedBar: true,
    },
    filters: [],
    service: new Service(),
    selectedRows: [],
    records: [],
    conditions: [],
    selectedCustomColums: [],
    selectedAdvanceFilterConditions: [],
    selectedFilterConditions: [],
    paginationSizeSelector: [10, 50, 100],
    paginationSize: 10,
    columns: [],
    userRole: "admin",
    modelKey: "",
    parentId: "",
    switchToAdvanceFilter: false,
    isShow: false,
    cColumnSort: [],
    displayRowCount: 10,
    isLoading: false,
    allResizeColumns: [],
    cellEditableStatus: true,
    viewId: "",
    columnSelectionDisabledCount: 2,
    currentPageNo: 1,
    allowCellEditOption: true,
    apiThatReturnedError: "",
    apiBrowseUrl: "",
    apiTrashedBrowseUrl: "",
    apiMultiUpdateUrl: "",
    isActionColumnVisible: true,
    browseAll: false,
    browseOwn: false,
    browseTeam: false,
    recordBrowseAll: false,
    recordBrowseAllApiUrl: "",
    recordBrowseOwn: false,
    recordBrowseOwnApiUrl: "",
    recordBrowseAssignedTo: false,
    recordBrowseAssignedToApiUrl: "",
    recordBrowseBelongsTo: false,
    recordBrowseBelongsToApiUrl: "",
    dataLoadErrorCode: "",
  }),
  created() {
    this.model.getByKey(this.$route.params.modelKey);
    this.modelKey = this.$route.params.modelKey;
    this.parentId = this.$route.params.parentId;
    this.viewId = this.$route.query.viewId;
    this.columns = this.$_.filter(
      this.model.browse.table.headers,
      (headers) => {
        return headers;
      },
    );
    this.allowCellEditOption = this.model.browse.table.actions.manageCellEdit;
    this.columnSelectionDisabledCount =
      this.model.browse.table.actions.columnSelectionDisabledCount;
    this.apiBrowseUrl = this.model.apiUrls.apiBrowseUrl;
    this.apiTrashedBrowseUrl = this.model.apiUrls.apiTrashedBrowseUrl;
    this.apiMultiUpdateUrl = this.model.apiUrls.apiMultiUpdateUrl;
    this.isActionColumnVisible =
      this.model.browse.table.actions.isActionColumnVisible;
    this.manageRoleBasedFunctionalityForBrowse();
    this.manageRoleBasedRecordAccessControll();

    var columnIndex = 0;
    for (var column of this.columns) {
      if (column.dataType == "modelParent") {
        var parentModel = new Model();
        parentModel.getByKey(column.modelKey);
        this.columns[columnIndex].formatter = (cell) => {
          var parent = cell.getRow().getData()[this.$_ucfirst(parentModel.key)];
          var parentLabel = parent.id;
          if (parent.name) parentLabel = parent.name;
          if (parentModel.column && parentModel.column.text)
            parentLabel = parent[parentModel.column.text];

          return `<span style="color:blue;">${parentLabel}</span>`;
        };

        this.columns[columnIndex].accessorDownload = (e, data) => {
          return data[this.$_ucfirst(parentModel.key)].name;
        };

        this.columns[columnIndex].cellClick = (e, cell) => {
          var parent = cell.getRow().getData()[this.$_ucfirst(parentModel.key)];
          var parentLabel = parent.id;
          this.$router.push({
            name: "PageServiceModelBreadTabulatorRead",
            params: {
              serviceKey: parentModel.serviceKey,
              modelKey: parentModel.key,
              modelId: parentLabel,
            },
          });
        };
      }

      if (column.dataType == "date") {
        this.columns[columnIndex].formatter = (cell) => {
          var exDate = cell.getValue();
          if (exDate) {
            return this.$moment(new Date(exDate)).format("YYYY-MM-DD");
          }
        };
      }
      columnIndex++;
    }

    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);
    if (this.model.browse.tools) this.tools = this.model.browse.tools;

    this.breadcrumbTabulator.addForOperationBrowse({
      model: this.model,
      services: this.services,
    });
  },
  mounted() {
    const viewId = this.$route.query.viewId;

    if (viewId !== "all" && viewId !== "trashed") {
      this.getAllViews(parseInt(viewId, 10));
    } else {
      this.getAllViews(viewId);
    }
  },
  methods: {
    apiGetBrowseUrl() {
      var userUuid = this.auth.uuid;
      var teamUuid = this.team;

      if (this.recordBrowseAll) {
        if (this.recordBrowseAllApiUrl != "") {
          return `${this.$service[this.service.key]}${
            this.recordBrowseAllApiUrl
          }`;
        } else {
          return `${
            this.$service[this.service.key]
          }/v1/en/console/tabulator/model/${this.model.key}/browse/all`;
        }
      }

      if (this.recordBrowseOwn) {
        if (this.recordBrowseOwnApiUrl != "") {
          return `${this.$service[this.service.key]}${
            this.recordBrowseOwnApiUrl
          }/${userUuid}`;
        } else {
          return `${
            this.$service[this.service.key]
          }/v1/en/console/tabulator/model/${this.model.key}/browse/all`;
        }
      }

      if (this.recordBrowseAssignedTo) {
        if (this.recordBrowseOwnApiUrl != "") {
          return `${this.$service[this.service.key]}${
            this.recordBrowseOwnApiUrl
          }/${userUuid}`;
        } else {
          return `${
            this.$service[this.service.key]
          }/v1/en/console/tabulator/model/${this.model.key}/browse/all`;
        }
      }

      if (this.recordBrowseBelongsTo) {
        if (this.recordBrowseBelongsToApiUrl != "") {
          return `${this.$service[this.service.key]}${
            this.recordBrowseBelongsToApiUrl
          }/${teamUuid}/listByTeamUuid/${this.auth.uuid}`;
        } else {
          return `${
            this.$service[this.service.key]
          }/v1/en/console/tabulator/model/${this.model.key}/browse/all`;
        }
      }
    },
    apiGetBrowseTrashUrl() {
      var userUuid = this.auth.uuid;
      var teamUuid = this.team;

      if (this.recordBrowseAll) {
        if (this.apiTrashedBrowseUrl != "") {
          return `${this.$service[this.service.key]}${
            this.apiTrashedBrowseUrl
          }`;
        } else {
          return `${
            this.$service[this.service.key]
          }/v1/en/console/tabulator/model/${this.model.key}/browse/trashed`;
        }
      }

      if (this.recordBrowseOwn) {
        if (this.recordBrowseOwnApiUrl != "") {
          return `${this.$service[this.service.key]}${
            this.apiTrashedBrowseUrl
          }/${userUuid}`;
        } else {
          return `${
            this.$service[this.service.key]
          }/v1/en/console/tabulator/model/${this.model.key}/browse/trashed`;
        }
      }

      if (this.recordBrowseAssignedTo) {
        if (this.recordBrowseOwnApiUrl != "") {
          return `${this.$service[this.service.key]}${
            this.apiTrashedBrowseUrl
          }/${userUuid}`;
        } else {
          return `${
            this.$service[this.service.key]
          }/v1/en/console/tabulator/model/${this.model.key}/browse/trashed`;
        }
      }

      if (this.recordBrowseBelongsTo) {
        if (this.recordBrowseBelongsToApiUrl != "") {
          return `${this.$service[this.service.key]}${
            this.apiTrashedBrowseUrl
          }/${teamUuid}/listByTeamUuid/${this.auth.uuid}`;
        } else {
          return `${
            this.$service[this.service.key]
          }/v1/en/console/tabulator/model/${this.model.key}/browse/trashed`;
        }
      }
    },
    manageRoleBasedFunctionalityForBrowse() {
      var roleBasedFunctionalityBrowse =
        this.model.roleBasedFunctionalities.browse;
      var userRoles = this.auth.roles.map((role) => {
        return role.slug;
      });

      for (var role of userRoles) {
        if (roleBasedFunctionalityBrowse.all.includes(role)) {
          this.browseAll = true;
          this.browseOwn = false;
          this.browseTeam = false;
        }

        if (roleBasedFunctionalityBrowse.own.includes(role)) {
          this.browseAll = false;
          this.browseOwn = true;
          this.browseTeam = false;
        }

        if (roleBasedFunctionalityBrowse.team.includes(role)) {
          this.browseAll = false;
          this.browseOwn = false;
          this.browseTeam = true;
        }
      }
    },
    //manage records based on the user role
    manageRoleBasedRecordAccessControll() {
      var roleBasedRecordAccessControll = this.model.recordAccessControl.browse;

      var manageAll = roleBasedRecordAccessControll.all;
      var manageAssignedTo = roleBasedRecordAccessControll.assignedTo;
      var manageBelongsTo = roleBasedRecordAccessControll.belongsTo;
      var manageOwn = roleBasedRecordAccessControll.own;
      var userRoles = this.auth.roles.map((role) => {
        return role.slug;
      });

      // check user role has manageAll access roles
      for (var role of userRoles) {
        if (manageAll.roles.includes(role)) {
          this.recordBrowseAll = true;
          this.recordBrowseAllApiUrl = manageAll.apiUrl;
        }

        if (manageAssignedTo.roles.includes(role)) {
          this.recordBrowseAssignedTo = true;
          this.recordBrowseAssignedToApiUrl = manageAssignedTo.apiUrl;
        }

        if (manageBelongsTo.ssoTeam.roles.includes(role)) {
          this.recordBrowseBelongsTo = true;
          this.recordBrowseBelongsToApiUrl = manageBelongsTo.ssoTeam.apiUrl;
        }

        if (manageOwn.roles.includes(role)) {
          this.recordBrowseOwn = true;
          this.recordBrowseOwnApiUrl = manageOwn.apiUrl;
        }
      }
    },
    setFiltersViaConditions(conditions) {
      this.$refs.filter.setFiltersViaConditions(conditions);
    },
    getConditions() {
      return this.conditions;
    },
    setConditions(conditions) {
      this.selectedFilterConditions = conditions;
      this.conditions = conditions;
      this.$refs.tabulatorDataTable.getFilterCondition(conditions);
    },
    setAdvancedFilterConditions(advanceFilterParams) {
      this.selectedAdvanceFilterConditions = advanceFilterParams;
      this.$refs.tabulatorDataTable.setAdvancedFilterConditions(
        advanceFilterParams,
      );
    },
    applyColumnSelection(selectedColumns) {
      this.selectedCustomColums = selectedColumns;
      this.$refs.tabulatorDataTable.applyColumnSelection(selectedColumns);
    },
    getCurrentPageSize(pagesize) {
      this.displayRowCount = pagesize;
    },
    getCurrentSort(sorters) {
      this.cColumnSort = sorters;
      this.cColumnSort = sorters.map((sorter) => {
        return {
          column: sorter.field,
          dir: sorter.dir,
        };
      });
    },
    getCurrentColumnWidth(resizedColumns) {
      const resizedColumnField = resizedColumns.getField();
      const resizedColumnWidth = resizedColumns.getWidth();
      //set the resized column width and filed name to the array
      const resizedColumnWidthAndField = {
        field: resizedColumnField,
        width: resizedColumnWidth,
      };

      const index = this.allResizeColumns.findIndex((item) => {
        return item.field === resizedColumnField;
      });

      if (index !== -1) {
        this.allResizeColumns[index].width = resizedColumnWidth;
      } else {
        this.allResizeColumns.push(resizedColumnWidthAndField);
      }
    },
    changeTableDetails(listAllViews, viewId) {
      // get the view details from listAllViews where id is equal to viewId
      if (viewId == "trashed") {
        this.$refs.tabulatorDataTable.callApiUrl(this.apiGetBrowseTrashUrl());
        this.$refs.selectColumn.showAllColumns([]);
        this.$refs.tabulatorDataTable.callSavedHeaderWidth([]);
        this.$refs.search.getFilterCondition([]);
        this.$refs.customView.changeSelectedTabStatus("trashed", 0);
      } else if (viewId == "all") {
        this.$refs.tabulatorDataTable.callSavedHeaderWidth([]);
        this.$refs.selectColumn.showAllColumns([]);
        this.$refs.search.getFilterCondition([]);
        this.$refs.customView.changeSelectedTabStatus("all", 1);
        this.setCurrentPageTo();
      } else {
        const tabIndex =
          listAllViews.indexOf(listAllViews.find((x) => x.id === viewId)) + 2;
        this.$refs.customView.changeSelectedTabStatus(viewId, tabIndex);
        const singleViewDetail = listAllViews.filter((item) => {
          return item.id === viewId;
        });

        if (singleViewDetail.length > 0) {
          if (
            JSON.parse(singleViewDetail[0].manageColumnCustomWidth).length > 0
          ) {
            this.$refs.tabulatorDataTable.callSavedHeaderWidth(
              JSON.parse(singleViewDetail[0].manageColumnCustomWidth),
            );
          }
          this.$refs.selectColumn.showViewSelectedColumns(
            JSON.parse(singleViewDetail[0].cColumnCondition),
          );

          if (JSON.parse(singleViewDetail[0].filterCondition).length > 0) {
            this.$refs.filter.setFiltersViaConditions(
              JSON.parse(singleViewDetail[0].filterCondition),
            );
          }

          if (JSON.parse(singleViewDetail[0].cColumnSort).length > 0) {
            this.$refs.tabulatorDataTable.callSavedColumnSort(
              JSON.parse(singleViewDetail[0].cColumnSort),
            );
          }

          if (singleViewDetail[0].displayRowCount != this.paginationSize) {
            this.$refs.tabulatorDataTable.callSavedPageSize(
              singleViewDetail[0].displayRowCount,
            );
          }
          // filter records only in the specific view tab
          this.$refs.search.getFilterCondition(
            JSON.parse(singleViewDetail[0].filterCondition),
          );
        }
        this.setCurrentPageTo();
      }
    },
    getAllViews(viewId) {
      this.api.setMethod(`GET`);
      this.api.setUrl(
        `${this.$service.hrdc}/v1/en/console/crmView/list?modelKey=${this.model.key}`,
      );

      this.api.setCallbackError(() => {
        this.apiThatReturnedError = this.api;
      });

      this.api.setCallbackCompleted((response) => {
        const privateViews = response.filter((view) => {
          return view.isPrivate === true && view.ownerUuid === this.auth.uuid;
        });

        // get all public views
        const publicViews = response.filter((view) => {
          return view.isPrivate === false;
        });

        // push all private and public views to listAllViews
        this.listAllViews = [...publicViews, ...privateViews];
        this.changeTableDetails(this.listAllViews, viewId);
      });
      this.api.fetch();
    },
    downloadData(fileType, rowsType) {
      this.isLoading = true;

      if (rowsType == "selected") {
        // check if any row is selected or not
        if (
          this.$refs.tabulatorDataTable.tabulator.getSelectedData().length == 0
        ) {
          this.isLoading = false;
          this.$store.dispatch("showMessage", {
            message: "Please select at least one row to download",
            messageType: "info",
            timeout: 2000,
          });
          return;
        }
      }

      switch (fileType) {
        case "csv":
          this.downloadCsvData(rowsType);
          break;
        case "xlsx":
          this.downloadExcelData(rowsType);
          break;
        case "pdf":
          this.downloadPdfData(rowsType);
          break;
        default:
          break;
      }
    },
    downloadCsvData(rowsType) {
      this.$refs.tabulatorDataTable.tabulator.download(
        "csv",
        `${this.model.key}.csv`,
        {
          sheetName: `${this.model.key}`,
        },
        rowsType == "selected" ? "selected" : "all",
      );
      this.isLoading = false;
      // unchecked all the selected rows
      this.$refs.tabulatorDataTable.tabulator.deselectRow();
    },
    downloadExcelData(rowsType) {
      this.$refs.tabulatorDataTable.tabulator.download(
        "xlsx",
        `${this.model.key}.xlsx`,
        {
          sheetName: `${this.model.key}`,
        },
        rowsType == "selected" ? "selected" : "all",
      );
      this.isLoading = false;
      this.$refs.tabulatorDataTable.tabulator.deselectRow();
    },
    downloadPdfData(rowsType) {
      this.$refs.tabulatorDataTable.tabulator.download(
        "pdf",
        `${this.model.key}.pdf`,
        {
          orientation: "portrait", //set page orientation to portrait
          title: "Demo Product Details", //add title to report
        },
        rowsType == "selected" ? "selected" : "all",
      );
      this.isLoading = false;
      this.$refs.tabulatorDataTable.tabulator.deselectRow();
    },
    setIsEditableCell(isEditable) {
      var viewId = this.$route.query.viewId;

      if (viewId != "all" && viewId != "trashed") {
        viewId = parseInt(viewId, 10);
        this.getEachViewStoredColumns(viewId, isEditable);
      } else {
        for (let column in this.columns) {
          if (this.columns[column].editable == !isEditable) {
            this.columns[column].editable = isEditable;
          }
        }
        this.$refs.tabulatorDataTable.tabulator.setColumns(this.columns);

        this.cellEditableStatus = !isEditable;
      }
    },
    getEachViewStoredColumns(viewId, isEditable) {
      this.api.setMethod("GET");
      this.api.setUrl(
        `${this.$service.hrdc}/v1/en/console/crmView/${viewId}/columns`,
      );

      this.api.setCallbackError(() => {
        this.apiThatReturnedError = this.api;
      });

      this.api.setCallbackCompleted((response) => {
        var storedColumns = JSON.parse(response.cColumnCondition);

        var newColums = [];

        this.columns.forEach((column) => {
          if (storedColumns.includes(column.field)) {
            newColums.push(column);
          }
        });

        for (let column in newColums) {
          if (newColums[column].editable == !isEditable) {
            newColums[column].editable = isEditable;
          }
        }

        if (newColums.length > 0) {
          this.$refs.tabulatorDataTable.tabulator.setColumns(newColums);
        } else {
          for (let column in this.columns) {
            if (this.columns[column].editable == !isEditable) {
              this.columns[column].editable = isEditable;
            }
          }
          this.$refs.tabulatorDataTable.tabulator.setColumns(this.columns);
        }
        this.cellEditableStatus = !isEditable;
      });
      this.api.fetch();
    },
    updateEditedCellData(cell) {
      let editedRecordId = cell.getRow().getData().id;
      let editedRecordField = cell.getField();
      let editedRecordValue = cell.getValue();
      let editedRecordOldValue = cell.getOldValue();

      let columnDataType = cell.getColumn().getDefinition().dataType;

      if (columnDataType == "date") {
        editedRecordValue = new Date(editedRecordValue);
      }

      if (columnDataType == "dateWithBgColor") {
        editedRecordValue = new Date(editedRecordValue);
      }

      if (columnDataType == "modelDropdown") {
        let textColumn = cell.getColumn().getDefinition().textColumn;
        let apiServiceKey = cell.getColumn().getDefinition().apiServiceKey;
        let apiUrl = cell.getColumn().getDefinition().apiUrl;

        this.apiDropdown.setMethod("GET");
        this.apiDropdown.setUrl(
          `${this.$service[apiServiceKey]}${apiUrl}/${cell.getValue()}`,
        );

        this.apiDropdown.setCallbackError(() => {
          this.apiThatReturnedError = this.apiDropdown;
        });

        this.apiDropdown.setCallbackCompleted((response) => {
          let valueColumnData = response.name;
          editedRecordValue = valueColumnData;
          editedRecordField = textColumn;
          this.updateTableCellValue(
            editedRecordField,
            editedRecordValue,
            editedRecordId,
            editedRecordOldValue,
            cell,
          );
        });
        this.apiDropdown.fetch();
      }

      this.updateTableCellValue(
        editedRecordField,
        editedRecordValue,
        editedRecordId,
        editedRecordOldValue,
        cell,
      );
    },
    getCurrentPageNumber(pageno) {
      this.currentPageNo = pageno;
    },
    setCurrentPageTo() {
      var pageNo = this.$route.query.page || 1;
      this.$refs.tabulatorDataTable.tabulator.setPage(pageNo);
    },
    updateTableCellValue(
      editedRecordField,
      editedRecordValue,
      editedRecordId,
      editedRecordOldValue,
      cell,
    ) {
      var valid = cell.validate();

      if (valid == true) {
        if (editedRecordField !== undefined) {
          var responseData = {
            [editedRecordField]: editedRecordValue,
          };

          this.api.setMethod("POST");
          this.api.setParams({
            data: JSON.stringify(responseData),
          });

          if (this.apiMultiUpdateUrl != "") {
            this.api.setUrl(
              `${this.$service[this.service.key]}${
                this.apiMultiUpdateUrl
              }/${editedRecordId}/editDirectlyInTabulator`,
            );
          } else {
            this.api.setUrl(
              `${
                this.$service[this.service.key]
              }/v1/en/console/tabulator/model/${
                this.model.key
              }/${editedRecordId}/editDirectlyInTabulator`,
            );
          }

          this.api.setCallbackError(() => {
            this.apiThatReturnedError = this.api;
          });

          this.api.setCallbackCompleted(() => {
            var columnDataType = cell.getColumn().getDefinition().dataType;
            if (columnDataType == "modelDropdown") cell.getRow().reformat();
            this.$store.dispatch("showMessage", {
              message: "Updated successfully.",
              messageType: "success",
              timeout: 2000,
            });
          });

          this.$refs.tabulatorDataTable.updateTableRowData(
            editedRecordId,
            editedRecordField,
            editedRecordValue,
          );

          this.api.fetch();
        }
      } else {
        let validationType = valid[0].type;

        if (validationType == "unique") {
          this.$store.dispatch("showMessage", {
            message: "This field is already exist.",
            messageType: "error",
            timeout: 2000,
          });

          cell.restoreOldValue();
          return;
        }

        if (validationType == "required") {
          this.$store.dispatch("showMessage", {
            message: "This field is required.",
            messageType: "error",
            timeout: 2000,
          });
          cell.restoreOldValue();
          return;
        }

        if (validationType == "regex") {
          this.$store.dispatch(
            "showMessage",
            `Enter valid ${editedRecordField}`,
          );
          cell.restoreOldValue();
          return;
        }

        if (validationType == "min") {
          this.$store.dispatch(
            "showMessage",
            `Minimum ${valid[0].parameters} characters required.`,
          );
          cell.restoreOldValue();
          return;
        }

        if (validationType == "max") {
          this.$store.dispatch(
            "showMessage",
            `Maximum ${valid[0].parameters} characters allowed.`,
          );
          cell.restoreOldValue();
          return;
        }

        if (validationType == "minLength") {
          this.$store.dispatch(
            "showMessage",
            `Maximum ${valid[0].parameters} characters allowed.`,
          );
          cell.restoreOldValue();
          return;
        }

        if (validationType == "maxLength") {
          this.$store.dispatch(
            "showMessage",
            `Maximum ${valid[0].parameters} characters allowed.`,
          );
          cell.restoreOldValue();
          return;
        }

        if (validationType == "numeric") {
          this.$store.dispatch(
            "showMessage",
            `Enter valid ${editedRecordField}`,
          );
          cell.restoreOldValue();
          return;
        }

        if (validationType == "float") {
          this.$store.dispatch(
            "showMessage",
            `Enter valid ${editedRecordField}`,
          );
          cell.restoreOldValue();
          return;
        }

        if (validationType == "integer") {
          this.$store.dispatch(
            "showMessage",
            `Enter valid ${editedRecordField}`,
          );
          cell.restoreOldValue();
          return;
        }

        this.$store.dispatch("showMessage", {
          message: "This field is required.",
          messageType: "error",
          timeout: 2000,
        });
        cell.restoreOldValue();
        return;
      }
    },
    getSelectedRows(data) {
      this.selectedRows = data;
    },
    getDataLoadErrorCode(errorCode) {
      this.dataLoadErrorCode = errorCode;
    },
  },
};
</script>
<style>
.btn-primary {
  background-color: #1976d2;
  color: #fff;
  border-radius: 4px;
  padding: 5px 10px;
  border: none;
  cursor: pointer;
}

.btn-delete-hard {
  background-color: #ff0000;
  color: #fff;
  border-radius: 4px;
  padding: 7px 10px;
  border: none;
  cursor: pointer;
}
</style>
